import {makeStyles, Theme} from '@material-ui/core';
import {Nullable} from 'common/types';
import {IconVerifiedBorder} from 'components/Icons';
import {ProIcon} from 'components/ProLabel';
import {ResizedImage} from 'components/ResizedImage';
import React, {FunctionComponent} from 'react';
import cx from 'classnames';
import {useIsRieltorApp} from '../../../hooks/useIsRieltorApp';

export interface UserAvatarProps {
  imageKey?: Nullable<string>;
  width: number;
  height: number;
  isVerified?: boolean;
  isPro?: boolean;
  placement?: number;
  iconSize?: 'sm' | 'md' | 'lg';
}

const useStyles = makeStyles<Theme, UserAvatarProps>(theme => ({
  avatarWrapper: {
    position: 'relative',
    width: props => props.placement,
    height: props => props.placement,
  },
  placement: {
    width: props => props.placement,
    height: props => props.placement,
    borderRadius: '50%',
  },
  verified: {
    position: 'absolute',
    '&.sm': {
      top: '-7px',
      right: '-7px',
      fontSize: '24px',
    },
    '&.md': {
      top: '-7px',
      right: '-7px',
      fontSize: '34px',
    },
    '&.lg': {
      top: '0',
      right: '0',
      fontSize: '40px',
    },
  },
  proLabel: {
    position: 'absolute',
    '&.sm': {
      bottom: '-4px',
      right: '-4px',
    },
    '&.md': {
      bottom: '-4px',
      right: '-4px',
    },
    '&.lg': {
      bottom: '-4px',
      right: '-4px',
    },
  },
}));

const UserAvatar: FunctionComponent<UserAvatarProps> = (
  props: UserAvatarProps
) => {
  const {
    imageKey,
    width,
    height,
    isVerified,
    isPro,
    iconSize = 'sm',
  } = props;
  const classes = useStyles(props);
  const isRieltorApp = useIsRieltorApp();

  return (
    <div className={classes.avatarWrapper}>
      {
        imageKey
          ? <ResizedImage
            imageKey={imageKey}
            width={width}
            height={height}
            round={true}
            className={classes.placement}
          />
          : <img
            className={classes.placement}
            src={require('screens/common/assets/placeholder.svg')}
            alt=""
          />
      }

      {
        isVerified
          ? <IconVerifiedBorder className={`${classes.verified} ${iconSize}`}/>
          : null
      }

      {
        isPro ? <ProIcon
            variant={iconSize === 'lg' ? 'big' : iconSize === 'md' ? 'medium' : 'small'}
            className={`${classes.proLabel} ${iconSize}`}
          />
          : null
      }
    </div>
  );
};

export default UserAvatar;
